export default __webpack_public_path__ + "static/media/profile_icon.98204d94.svg";